import React from 'react';
import '../allcss/head.css';
import meetaImg from '../Asets/gallery1.jpg'; // Replace with updated full image

const HeadOfSchool = () => {
  return (
    <div className="unique-head-wrapper">
      <div className="unique-head-card">
        <div className="unique-head-image-section">
          <img src={meetaImg} alt="Meeta Gupta" className="unique-head-fullimage" />
        </div>
        <div className="unique-head-content">
          <h2 className="unique-head-title">Meet Our Head of School</h2>
          <h3 className="unique-head-name">Meeta Gupta</h3>
          <p className="unique-head-description">
           With a passion for early childhood education, Meeta Gupta leads RED School House with a vision of creating a safe, nurturing, and inspiring learning environment. She is committed to helping every child build confidence, curiosity, creativity, and strong values through meaningful early learning experiences. Her child-centred approach and dedication to quality education ensure that every child receives the care, guidance, and support needed to thrive.
          </p>
        
          <div className="unique-head-quote-box">
            <p className="unique-head-quote">"Every child has unique potential. Our mission is to nurture confident, compassionate, and curious learners in a joyful environment where they feel safe, valued, and inspired to grow."</p>
            <span className="unique-head-sign">– Meeta Gupta</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadOfSchool;


